module.exports = __webpack_public_path__ + "static/media/tab_open_hover.1471fd69.svg";